import { z } from 'zod';
import { COLOR_SCHEMA } from '../../../color';
import { FONT_FAMILY_SCHEMA } from '../../../fonts';
export const EmailLayoutPropsSchema = z.object({
    backdropColor: COLOR_SCHEMA,
    borderColor: COLOR_SCHEMA,
    borderRadius: z.number().optional().nullable(),
    canvasColor: COLOR_SCHEMA,
    textColor: COLOR_SCHEMA,
    fontFamily: FONT_FAMILY_SCHEMA,
    childrenIds: z.array(z.string()).optional().nullable(),
});
//# sourceMappingURL=EmailLayoutPropsSchema.js.map